@if (!guideIsOpened) {
  <breadcrumb endText="Guides" />
}
@if (!guideIsOpened) {
  <div class="m-5 pb-5">
    <div class="font-medium text-xl mb-2">
      Guides
    </div>
    <hr />
    <search-bar [(searchText)]="searchText" />
    @for (guide of guides; track guide; let i = $index) {
      <div>
        @if (guide.name.toLowerCase().includes(searchText.toLowerCase())) {
          <div [ngClass]="i % 2 === 0? 'flex w-full mt-2 p-2 rounded-[8px] hover:bg-gray-200': 'flex w-full mt-2 p-2 rounded-[8px] bg-gray-100 hover:bg-gray-200'">
            <button (click)="openGuide(guide.src, guide.name)" class="flex justify-between w-full p-3 rounded-[8px]">
              {{guide.name}}
              <fa-icon [icon]="faChevronRight" />
            </button>
          </div>
        }
      </div>
    }
  </div>
}
@if (guideIsOpened) {
  <div class="flex flex-col h-full">
    <breadcrumb [endText]="selectedGuide.name" [navigations]="breadcrumbNavs" />
    <iframe [src]="transform(selectedGuide.src)" class="flex-grow h-full" allowfullscreen frameborder="0"></iframe>
  </div>
}
